import { Provider, Type } from '@angular/core';
import { AttachmentService } from '@interacta-shared/data-access-caronte';
import { Attachment } from '@interacta-shared/util-caronte';
import { StorageFile } from '@interacta-shared/util-common';

export const provideAttachment = <
    A extends Attachment,
    SF extends StorageFile,
    T extends AttachmentService<A, SF>,
>(
    implementation: Type<T>,
): Provider => ({
    provide: AttachmentService,
    useClass: implementation,
});
